import { initialReasonsState, IReasonsState } from '../state/reasons.state';
import { ReasonsAction } from '../constants/reasons.constants'


export const reasonsReducer = (
    state = initialReasonsState,
    action: any,
): IReasonsState => {
    switch (action.type) {
        case ReasonsAction.GetReasonsSuccess: {
            return {
                ...state,
                reasons: action.data.results,
            };
        }

        case ReasonsAction.GetReasonByIdSuccess: {
            return {
                ...state,
                selectedReason: action.data,
            };
        }

        case ReasonsAction.PostReasonSuccess: {
            return {
                ...state,
                reasons: [...state.reasons, action.data],
            };
        }

        case ReasonsAction.PutReasonSuccess: {
            return {
                ...state,
                reasons: state.reasons.map(reason =>
                    reason.id === action.data.id ? action.data : reason
                ),
                selectedReason: action.data
            };
        }

        case ReasonsAction.DeleteReasonSuccess: {
            return {
                ...state,
                reasons: state.reasons.filter(reason => reason.id !== action.id),
                selectedReason: null
            };
        }

        default:
            return state;
    }
};